<div
  class="tw-flex tw-flex-col tw-gap-6 tw-m-4 tw-border tw-border-color-border-subtle tw-rounded-xl tw-shadow-button tw-py-5"
>
  <div class="tw-grid tw-grid-flow-col tw-gap-1 tw-px-4 tw-items-start tw-justify-start">
    <div class="tw-row-span-2 tw-text-gray-600 tw-pr-1">
      <icon [name]="'iPhone'" [size]="12"></icon>
    </div>
    @if (deviceDetector.isMobile()) {
      <div class="tw-col-span-1 tw-text-[14px] tw-text-gray-800 tw-font-semibold">
        {{ "mobileiOSPlatform" | i18n }}
      </div>
      <div class="tw-text-[13px] tw-text-gray-500">
        {{ "mobileiOSPlatformDesc" | i18n }}
      </div>
    } @else {
      <div class="tw-col-span-1 tw-text-[14px] tw-text-gray-800 tw-font-semibold tw-pl-2">
        {{ "webiOSPlatform" | i18n }}
      </div>
      <div class="tw-text-[13px] tw-text-gray-500 tw-pl-2">
        {{ "webiOSPlatformDesc" | i18n }}
      </div>
    }
  </div>

  <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full tw-px-4 tw-font-sans">
    <div
      class="tw-relative tw-flex tw-items-center tw-bg-dt-surface-card tw-border tw-border-color-border-subtle tw-rounded-xl tw-py-3 tw-px-5"
    >
      <div class="tw-flex-1 tw-overflow-hidden">
        <span class="tw-text-gray-600 tw-text-lg tw-truncate tw-block">{{ offerCode() }}</span>
      </div>

      <div class="tw-relative tw-ml-4">
        <!-- Tooltip -->
        <div
          [class.tw-opacity-100]="showTooltip()"
          [class.tw-translate-y-0]="showTooltip()"
          [class.tw-opacity-0]="!showTooltip()"
          [class.tw-translate-y-2]="!showTooltip()"
          class="tw-absolute tw--top-12 tw-left-1/2 tw--translate-x-1/2 tw-bg-dt-custom-teal-9 tw-text-dt-text-contrast tw-text-sm tw-py-2 tw-px-4 tw-rounded-full tw-transition-all tw-duration-200 tw-pointer-events-none tw-whitespace-nowrap"
        >
          Copied
          <!-- Tooltip Arrow -->
          <div
            class="tw-absolute tw-bottom-1 tw-left-1/2 tw-translate-x-1/2 tw-w-2 tw-h-2 tw-bg-dt-custom-teal-9 tw-rotate-45"
          ></div>
        </div>

        <!-- Copy Button -->
        <app-gloss-button
          (click)="copyToClipboard()"
          [options]="{
            icon: 'copy-06',
            ariaLabel: 'copyCode' | i18n,
            isEnabled: true,
            fullClass:
              'tw-text-dt-text-action tw-flex tw-items-center tw-border tw-border-solid tw-bg-[#F0F0F3] tw-h-[40px] tw-w-[56px] tw-justify-center tw-border-neutral-100 tw-px-2 tw-py-2 tw-rounded-lg',
          }"
        >
        </app-gloss-button>
      </div>
    </div>
  </div>

  <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
    @if (deviceDetector.isMobile()) {
      <div
        (click)="openRedemptionSheet()"
        class="tw-flex tw-items-center tw-gap-1 tw-cursor-pointer hover:tw-underline active:tw-opacity-70 tw-transition-all"
      >
        <span class="tw-text-dt-text-action tw-underline tw-font-semibold tw-text-[14px] tw-pr-1">
          {{ "redeemAtIosPlatform" | i18n }}
        </span>
        <icon class="tw-text-dt-text-action" [name]="'direct'" [size]="4"></icon>
      </div>

      <div
        (click)="redeemAtPrefilledURL()"
        class="tw-flex tw-items-center tw-gap-1 tw-cursor-pointer hover:tw-underline active:tw-opacity-70 tw-transition-all"
      >
        <span class="tw-text-dt-text-action tw-underline tw-font-semibold tw-text-[14px] tw-pr-1">
          {{ "redeemAtExternalURL" | i18n }}
        </span>
        <icon class="tw-text-dt-text-action" [name]="'direct'" [size]="4"></icon>
      </div>
    } @else {
      <div
        class="tw-flex tw-items-center tw-gap-1 tw-cursor-pointer hover:tw-underline active:tw-opacity-70 tw-transition-all"
      >
        <span class="tw-text-dt-text-action tw-underline tw-font-semibold tw-text-[14px] tw-pr-1">
          {{ "visitWebsiteToUse" | i18n }}
        </span>
        <icon class="tw-text-dt-text-action" [name]="'direct'" [size]="4"></icon>
      </div>
    }
  </div>
</div>
